export const startsWith = (source: string, target: string) => {
  return source.indexOf(target) === 0;
};
